import styled from 'styled-components';

import mediaQueries from 'constants/mediaQueries';
import { colorBrandSecondary } from 'constants/colors';
import {
  H2 as _H2,
  H3 as _H3,
  ParagraphRegular as _ParagraphRegular,
} from 'components/shared/typography';

const spacing = {
  desktop: {
    padding: 96,
    gap: 64,
  },
  mobile: {
    padding: 56,
    gap: 18,
  },
};

const image = {
  desktop: {
    width: 395,
    height: 370,
  },
  mobile: {
    width: 320,
    height: 280,
  },
};

const MARGIN_DESKTOP = image.desktop.width + spacing.desktop.gap;
const MARGIN_MOBILE = image.mobile.height + spacing.desktop.gap;

export const FlexWrapper = styled.div`
  padding: ${spacing.desktop.padding}px 0 32px 0;
  min-height: 458px;
  position: relative;

  ${mediaQueries.mobileOnly} {
    padding-top: ${spacing.mobile.padding}px;
    padding-bottom: ${MARGIN_MOBILE}px;
  }
`;

export const H2 = styled(_H2)``;
export const H3 = styled(_H3)``;
export const ParagraphRegular = styled(_ParagraphRegular)``;
export const Link = styled.a`
  color: ${({ color }) => color || colorBrandSecondary};
  text-decoration: underline;
  font-size: 14px;
`;

// HACK: this allows to increase specificity and apply margins
export const Title = styled.div`
  margin-right: ${MARGIN_DESKTOP}px;

  > ${H2} {
    margin-bottom: 24px;
  }

  > ${H3} {
    margin-bottom: 16px;
  }

  > ${ParagraphRegular} {
    margin-bottom: 16px;
  }

  ${mediaQueries.mobileOnly} {
    margin-right: 0px;
  }
`;

export const PromoButtons = styled.div`
  margin-top: 24px;
`;

export const PromoButton = styled.a`
  display: inline-block;
  margin: 0;
  text-decoration: none;
  margin-right: 16px;

  > img {
    width: 136px;
  }
`;

export const PromoImage = styled.img`
  position: absolute;
  bottom: 0px;
  right: 0px;
  object-fit: contain;
  object-position: bottom;
  width: ${image.desktop.width}px;
  height: ${image.desktop.height}px;

  ${mediaQueries.mobileOnly} {
    left: 0;
    right: 0;
    margin: auto;
    width: ${image.mobile.width}px;
    height: ${image.mobile.height}px;
  }
`;
